// client/src/routes/link/incident.$token.tsx — SCR-LINK-002 „Raportare incident (link)" ·
// PORTAL-002 phase 3 (04 §6.7, §8.16).
//
// The same three absences as its sibling `meter.$token.tsx`, for the same three reasons: no
// `beforeLoad` (no login means no session bootstrap), the token is sent and never rendered, and
// every request goes through `features/links/anonymous-client.ts` rather than the configured
// client (D-1185).
//
// The one difference from the meter page is what is NOT here: no list. SCR-PORT-004 shows the
// tenant their own incident history because they are signed in; a link holder is not, there is
// no anonymous route that lists tickets, and a link forwarded to a group chat must not become a
// window onto every complaint the flat has filed. See `IncidentLinkForm`.

import { createFileRoute } from '@tanstack/react-router';

import { IncidentLinkForm } from '@/features/links/IncidentLinkForm';
import { LinkPage } from '@/features/links/LinkPage';

export const Route = createFileRoute('/link/incident/$token')({
  component: IncidentLinkScreen,
});

function IncidentLinkScreen() {
  const { token } = Route.useParams();

  return (
    <LinkPage token={token} expects="INCIDENT">
      {(context) => <IncidentLinkForm token={token} context={context} />}
    </LinkPage>
  );
}
